export default __webpack_public_path__ + "static/Blind-angels-zakia-video-c8677197784d33a6ab59f534f3ae1e2c.png";